<template>
  <div class="content">
    <div class="top">
      <div class="elec_speed">
        <el-steps :active="0" finish-status="success" simple>
          <el-step :title=Selectionofparameters></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <div class="elec_select">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple elec_select_left">
            <img :src=picUrl alt="">
            <div class="text">{{$t('message.Selectionofparameters')}}</div>
          </div>
        </el-col>
        <!-- 多级选择菜单 -->
        <el-col :span="12">
          <div class="grid-content bg-purple-light elec_select_right">
            <div class="select_box">
              
              <div>
                <span style="padding-right:10px;width:100px;display:inline-block;">{{$t('message.SelectedSeriesName')}}</span>
                <el-cascader
                  :options="options"
                  v-model="selectedOptions"
                  :props="optionProps"
                  @change="handleChange"
                  @click.native="_getName()"
                  :show-all-levels="false">
                </el-cascader>
              </div>
              <div style="padding-top:30px;">
                <span style="padding-right:10px;width:100px;display:inline-block;">{{$t('message.SelectedSpecifications')}}</span>
                <el-cascader
                  :options="options_2"
                  v-model="selectedOptions_2"
                  :props="optionProps_2"
                  @change="handleChange_2"
                  @click.native="_getSpecs()"
                  :show-all-levels="false">
                </el-cascader>
              </div>
              <!-- <div style="padding-top:30px;">
                <span style="padding-right:10px;width:100px;display:inline-block;">{{$t('message.SelectedSeries')}}</span>
                <el-cascader
                  :options="options_3"
                  v-model="selectedOptions_3"
                  :props="optionProps_3"
                  @change="handleChange_3"
                  @click.native="_getLevel()"
                  :show-all-levels="false">
                </el-cascader>
              </div> -->
              <div style="padding-top:30px;">
                <span style="padding-right:10px;width:100px;display:inline-block;">{{$t('message.Selecteddecelerationratio')}}</span>
                <el-cascader
                  :options="options_4"
                  v-model="selectedOptions_4"
                  :props="optionProps_4"
                  @change="handleChange_4"
                  @click.native="_getRatio()"
                  :show-all-levels="false">
                </el-cascader>
              </div>
              <div style="padding-top:30px;">
                <span style="padding-right:10px;width:100px;display:inline-block;">{{$t('message.SelectMotorSize')}}</span>
                <el-cascader
                  :options="options_5"
                  v-model="selectedOptions_5"
                  :props="optionProps_5"
                  @change="handleChange_5"
                  @click.native="_getMotorSize()"
                  :show-all-levels="false">
                </el-cascader>
              </div>
              <!-- <div style="padding-top:30px;">
                <span style="padding-right:10px;width:100px;display:inline-block;">{{$t('message.WhetherWithAKey')}}</span>
                <el-cascader
                  :options="options_6"
                  v-model="selectedOptions_6"
                  :props="optionProps_6"
                  @change="handleChange_6"
                  :show-all-levels="false">
                </el-cascader>
              </div> -->
              <div class="toNextPage" @click="toNextPage">{{$t('message.Next')}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 备注 -->
    <!-- <div class="elec_detail">
      <el-row>
        <el-col :span="24" style="margin-bottom:20px;">
          <h3>{{$t('message.ReducerModelTable')}} <span style="font-size:14px;color:red;padding-left:10px;">{{$t('message.info07')}}</span> </h3>
        </el-col>
        <el-col :span="24" style="margin-bottom:20px;">
          <label v-for="(item,index) in radioData" :key="index">
          <el-col :span="4" class="size_radio">
            <input v-model="radioParam" @click="getRadioVal(item.reducer_type)" type="radio" name="type" :value="item.reducer_type">{{item.reducer_type}}
          </el-col>
          </label>
        </el-col>
      </el-row>
    </div> -->
  </div>
</template>
<script>
  import {
    getName,
    getSpecs,
    getLevel,
    getRatio,
    getMotorSize,
    getSizeList,
    getSizeList2
  } from '@/store/electric_param'
  import {
    getPicUrl
  } from '@/store/electric_motor'
  const options_6_cn = [{ is_with_key: '是'},{is_with_key: '否'}]
  const options_6_en = [{ is_with_key: 'YES'},{is_with_key: 'NO'}]
  export default {
    name: 'SelectedMotor',
    data() {
      return {
        options: [],
        selectedOptions: [],
        optionProps: {
          value: 'reducer_series_name',
          label: 'reducer_series_name',
        },
        options_2: [],
        selectedOptions_2: [],
        optionProps_2: {
          value: 'specifications',
          label: 'specifications',
        },
        options_3: [],
        selectedOptions_3: [],
        optionProps_3: {
          value: 'reducer_level',
          label: 'reducer_level',
        },
        options_4: [],
        selectedOptions_4: [],
        optionProps_4: {
          value: 'reduction_ratio',
          label: 'reduction_ratio',
        },
        options_5: [],
        selectedOptions_5: [],
        optionProps_5: {
          value: 'motor_formula',
          label: 'motor_formula',
        },
        options_6: localStorage.getItem('lang') == 'cn' ? options_6_cn : options_6_en,
        selectedOptions_6: '',
        optionProps_6: {
          value: 'is_with_key',
          label: 'is_with_key',
        },
        tabPosition: 'left',
        param:{},
        radioData:[],
        param2:{},
        Selectionofparameters:this.$t('message.Selectionofparameters'),
        complete:this.$t('message.complete'),
        picUrl:'',
        radioParam:''
      };
    },
    mounted() {
      this.picUrl = '../../../static/seriesPic/KPL.png'
      this.param.is_with_key = '0'
      // this.selectedOptions_6 = [this.options_6[1].is_with_key]
      this.param2.is_with_key = this.param.is_with_key
    },
    methods: {
      toNextPage:function(){
        console.log(this.param);
        //if(this.param2.reducer_size){
        if(this.param.reducer_series_name && this.param.specifications && this.param.reduction_ratio && this.param.motor_formula && this.param.is_with_key){
          this.$emit("listenPageChange","to_CompletedPage");
          console.log(this.param2)
          this.$emit("listenParam",this.param2);
        }else{
          this.$message({
            message: '请确定各参数型号!',
            type: 'warning'
          });
        }
      },
      handleChange(val){
        this.param.reducer_series_name = val[0]
        getPicUrl(val[0]).then((response) => {
          if (response.success === true) {
            this.picUrl = response.data[0].outlook_picture
          }
        })
        //clear
        this.options_2 = [];
        this.options_4 = [];
        this.options_5 = [];
        
        this.radioData = [];
        this.param.specifications = '';
        this.param.reduction_ratio = '';
        this.param.motor_formula = '';
      },
      handleChange_2(val){
        this.param.specifications = val[0]
        //clear
        this.options_4 = [];
        this.options_5 = [];
        this.radioData = [];
        this.param.reduction_ratio = '';
        this.param.motor_formula = '';
      },
      handleChange_3(val){
        this.radioData = [];
        this.param.level = val[0]
      },
      handleChange_4(val){

        this.radioData = [];
        this.param.reduction_ratio = val[0]
        //clear
        this.options_5 = [];
        this.param.motor_formula = '';
      },
      handleChange_5(val){
        this.radioData = [];
        this.param.motor_formula = val[0]
        getSizeList2(this.param).then((response)=>{
          if(response.success === true){
            var arr = [];
            arr.push(response.data);
            this.radioData = arr;
            this.radioParam = this.radioData[0].reducer_type;
            this.param2.reducer_size = this.radioParam
            this.param2.specifications = this.param.specifications
            this.param2.reduction_ratio = this.param.reduction_ratio
            this.param2.reducer_series_name = this.param.reducer_series_name
            this.param2.motor_formula = this.param.motor_formula
            this.param2.is_with_key = this.param.is_with_key
          }
        })
      },
      handleChange_6(val){
        this.radioData = []; 
        this.param.is_with_key = val[0] == '否' ? '0' : '1'
        console.log(this.param.is_with_key)
        this.param2.is_with_key = this.param.is_with_key
      },
      _getName(){
        getName().then((response)=>{
          if(response.success === true){
            this.options = [];
            this.options = response.data;
          }
        })
      },
      _getSpecs(){
        getSpecs(this.param).then((response)=>{
          if(response.success === true){
            this.options_2 = [];
            this.options_2 = response.data;
          }
        })
      },
      _getLevel(){
        getLevel(this.param).then((response)=>{
          if(response.success === true){
            this.options_3 = [];
            this.options_3 = response.data;
          }
        })
      },
      _getRatio(){
        getRatio(this.param).then((response)=>{
          if(response.success === true){
            this.options_4 = [];
            const data = response.data;
            data.sort(this.sortNumber)
            this.options_4 = data;
          }
        })
      },
      sortNumber(a, b) {
        return a.reduction_ratio - b.reduction_ratio
      },
      _getMotorSize(){
        getMotorSize(this.param).then((response)=>{
          if(response.success === true){
            this.options_5 = []
            var options_5_array = []
            options_5_array = response.data;
            this.options_5 = options_5_array;
          }
        })
      },
      getRadioVal(value){
        this.param2.reducer_size = value
        this.param2.specifications = this.param.specifications
        this.param2.reduction_ratio = this.param.reduction_ratio
        this.param2.reducer_series_name = this.param.reducer_series_name
        this.param2.level = this.param.level
        this.param2.motor_formula = this.param.motor_formula
      }
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
    padding-bottom:100px;
  }
  .top {
    height:100px;
    border-bottom:1px solid #EBEBEB;
  }
  .elec_speed {
    width:25%;
    margin-left:50px;
    padding-top:25px;
  }
  .el-step.is-simple.is-flex{
    margin-right:8%;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../static/step.png') no-repeat #F5F7FA;
    background-size:50% 100%;
    background-position-x:0%;
  }
  .elec_select_left img{
    width: 35%;
    height: 35%;
    display: block;
    margin: 0 auto;
    padding-top: 100px;
  }
  .elec_select_left .text{
    text-align: center;
    font-weight: bold;
  }
  .el-cascader-menus el-popper{
    z-index: 2010;
    position: absolute;
    top: 284px;
    left: 952px;
  }
  .select_box {
    padding-left:10px;
    padding-top:80px;
  }
  .toNextPage {
    width:97px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    cursor: pointer;
  }
  .elec_detail {
    width:80%;
    margin:0 auto;
    margin-top:70px;
    margin-left:200px;
    margin-bottom:50px;
  }
  .elec_detail p {
    color:#D0174B;
    line-height: 30px;
  }
  .size_radio {
    line-height:40px;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .elec_detail {
      width:80%;
      margin:0 auto;
      margin-top:70px;
      margin-left:100px;
      margin-bottom:50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/MotorSelection/SelectedMotor.vue